export default __webpack_public_path__ + "static/media/logo.dd978e1a.png";